// Per-tab id sent on writes so a tab can ignore the SSE echo of its own changes.
export const CLIENT_ID_HEADER = 'X-Client-Id'

export const CLIENT_ID =
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : Math.random().toString(36).slice(2)
